const LINKS = {
    inAd: 'https://in-ad-buying.klickly.com/?allowAllSessions=true',
    '300x600': 'https://widget.klickly.com/?width=300&height=600&allowAllSessions=true',
    '728x90': 'https://widget.klickly.com/?width=728&height=90&allowAllSessions=true'
};

const useUnitLinks = ({ searchParams }) => {
    const brandId = searchParams.get('b');
    const version = searchParams.get('v');
    const awa300x600Layout = searchParams.get('al');
    const awa728x90Layout = searchParams.get('as');

    const processedLinks = { ...LINKS };

    if (brandId || version) {
        const src = new URL(processedLinks.inAd);

        if (brandId) {
            src.searchParams.set('brandId', brandId);
        }

        src.searchParams.set('version', version ? `v${version}` : 'v2');

        processedLinks.inAd = src.toString();
    }

    if (brandId || awa300x600Layout) {
        const src = new URL(processedLinks['300x600']);
        if (brandId) {
            src.searchParams.set('brandId', brandId);
        }

        src.searchParams.set('version', version ? `v${version}` : 'v2');

        if (awa300x600Layout) {
            src.searchParams.set('layout', `2311-300x600-V${awa300x600Layout}`);
        }
        processedLinks['300x600'] = src.toString();
    }

    if (brandId || awa728x90Layout) {
        const src = new URL(processedLinks['728x90']);
        if (brandId) {
            src.searchParams.set('brandId', brandId);
        }

        src.searchParams.set('version', version ? `v${version}` : 'v2');

        if (awa728x90Layout) {
            src.searchParams.set('layout', `2402-728x90-V${awa728x90Layout}`);
        }
        processedLinks['728x90'] = src.toString();
    }

    return processedLinks;
};

export default useUnitLinks;
